export const isMatchMaxWidth = (maxWidth) => (
	typeof matchMedia === 'undefined' || matchMedia(`(max-width: ${maxWidth}px)`).matches
);

export * from './social_share';